import {BANNER, MODAL} from '../notification-config';
function getField(type, location) {
    let field = {};
    switch (type) {
        case MODAL:
            field = {
                action_location: location || 'in-bottom',
                placement_type: MODAL,
            };
            break;
        default:
            field = {
                action_location: 'above-header',
                placement_type: BANNER,
            };
    }
    return field;
}
function handleDownloadEdapEvent(trackingContext, type) {
    const field = getField(type);
    trackingContext.trigger('native_adoption_placement.selected', field);
    trackingContext.trigger('native_adoption_placement.submitted', field);
}
function handleDismissEdapEvent(trackingContext, type, location) {
    const field = getField(type, location);
    trackingContext.trigger('native_adoption_placement.dismissed', field);
}
function handleOnloadEdapEvent(trackingContext, type) {
    const field = getField(type);
    trackingContext.trigger('native_adoption_placement.presented', field);
}
export {handleDownloadEdapEvent, handleDismissEdapEvent, handleOnloadEdapEvent};
